import { Avatar } from "antd";
import React from "react";

export default function Information({ client }) {
     const getInitials = (name) => {
          const nameParts = name?.trim()?.split(" ");
          if (nameParts) {
               const initials = nameParts[0][0] + nameParts[nameParts.length - 1][0];
               return initials.toUpperCase();
          }
     };

     return (
          <div>
               <div className=" m-4">
                    <div className="md:col-span-2 border rounded-lg">
                         <div className="p-4">
                              <p className="text-lg font-semibold">Account details</p>
                         </div>

                         <div className="border-y mx-4 mb-4 flex items-center gap-5 md:p-4">
                              <Avatar size={60} src={client?.profile_image} className="bg-primary">
                                   {getInitials(client?.name)}
                              </Avatar>
                              <div>
                                   <p className="text-lg font-semibold capitalize">{client?.name}</p>
                                   <p className="text-secondaryLight2 capitalize">{client?.account_type}</p>
                              </div>
                         </div>

                         <div className="flex items-center gap-12 mx-4 mb-4 md:px-4">
                              <div className="w-full flex flex-col gap-2">
                                   <div className="flex gap-5">
                                        <p className="font-medium w-20">Email</p>
                                        <p>{client?.email || "--"}</p>
                                   </div>
                                   <div className="flex gap-5">
                                        <p className="font-medium w-20">Phone</p>
                                        <p>{client?.mobile_no || "--"}</p>
                                   </div>
                                   <div className="flex gap-5">
                                        <p className="font-medium w-20">Status</p>
                                        <p>{client?.status || "--"}</p>
                                   </div>
                              </div>
                         </div>
                    </div>
               </div>
          </div>
     );
}
